import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare as faSquareRegular } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faChevronDown,
  faChevronUp,
  faClockRotateLeft,
  faCloudBolt,
  faDroplet,
  faGear,
  faLocationDot,
  faLocationPin,
  faMagnifyingGlass,
  faNotdef,
  faRotate,
  faSquareCheck,
  faTriangleExclamation,
  faWind,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

export enum Icons {
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ChevronDown = 'chevron-down',
  ChevronUp = 'chevron-up',
  ClockRotateLeft = 'clock-rotate-left',
  CloudBolt = 'cloud-bolt',
  Droplet = 'droplet',
  Gear = 'gear',
  LocationDot = 'location-dot',
  LocationPin = 'location-pin',
  MagnifyingGlass = 'magnifying-glass',
  NotDefined = 'notdef',
  Rotate = 'rotate',
  Square = 'square',
  SquareCheck = 'square-check',
  TriangleExclamation = 'triangle-exclamation',
  Wind = 'wind',
  Xmark = 'xmark',
}

export type IconProps = {
  name: Icons;
  testId?: string;
};

function Icon(props: IconProps & Omit<FontAwesomeIconProps, 'icon'>) {
  const { name, testId = 'icon', ...otherProps } = props;

  const selectIcon = (name: Icons): IconProp => {
    switch (name) {
      case Icons.ArrowLeft:
        return faArrowLeft;
      case Icons.ArrowRight:
        return faArrowRight;
      case Icons.ChevronDown:
        return faChevronDown;
      case Icons.ChevronUp:
        return faChevronUp;
      case Icons.ClockRotateLeft:
        return faClockRotateLeft;
      case Icons.CloudBolt:
        return faCloudBolt;
      case Icons.Droplet:
        return faDroplet;
      case Icons.Gear:
        return faGear;
      case Icons.LocationDot:
        return faLocationDot;
      case Icons.LocationPin:
        return faLocationPin;
      case Icons.MagnifyingGlass:
        return faMagnifyingGlass;
      case Icons.Rotate:
        return faRotate;
      case Icons.Square:
        return faSquareRegular;
      case Icons.SquareCheck:
        return faSquareCheck;
      case Icons.TriangleExclamation:
        return faTriangleExclamation;
      case Icons.Wind:
        return faWind;
      case Icons.Xmark:
        return faXmark;
      case Icons.NotDefined:
      default:
        return faNotdef;
    }
  };

  return <FontAwesomeIcon icon={selectIcon(props.name)} {...otherProps} data-testid={testId} />;
}

export default Icon;
